import styled from "styled-components";

export const ModalContainer = styled.div`
	display: flex;
	margin-top: 20px;
	> div + div {
		margin-left: 15px;
	}
`;

export const InputBlock = styled.div`
	width: 200px;
	> div {
		margin-top: 5px;
	}

	.DayPickerInput {
		width: 100%;
	}

	.DayPickerInput input {
		min-height: 38px;
		padding: 2px 8px;
		border-color: hsl(0, 0%, 80%) !important;
		max-width: 100%;
	}
	.DayPickerInput input:focus {
		border-color: #2684ff !important;
		box-shadow: none;
	}
`;
